<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      is_clicked: false
    }
  },

  props: [
    'is_small'
  ],

  created () {
    $('.btn-extend').tooltip()
  },

  methods: {
    ...mapActions([
      'getCurrentReservation',
      'patchCurrentReservation'
    ]),

    /*
     * Get the reservation transaction from the API.
     */
    extendReservation: function () {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      let payload = {
        self: this
      }

      this.patchCurrentReservation(payload)
    },
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
    }),

    isDisabled: function () {
      return !this.current.is_expiring || this.is_clicked
    }
  }
}
</script>

<template>
  <a
    href="#"
    data-toggle="tooltip"
    data-placement="top"
    title="+24 hour extension"
    @click.prevent="extendReservation"
    :class="{ 'opacity-50 cursor-not-allowed' : isDisabled, 'hover:text-white hover:no-underline hover:bg-riverbed-violet active:bg-riverbed-violet active:text-white active:no-underline focus:bg-riverbed-violet focus:text-white focus:no-underline ease-in-out duration-300 shadow md:after:absolute md:after:origin-center md:after:h-80 md:after:top-0 md:after:bottom-0 md:after:left-0 md:after:right-0 md:after:bg-riverbed-violet md:after:opacity-0 md:after:scale-x-0 md:after:ease-in-out md:after:duration-300 md:hover:after:opacity-100 md:hover:after:scale-x-110 md:hover:after:rotate-12 md:hover:after:-translate-y-1/2': ! isDisabled, 'px-2 py-1': is_small, 'px-4 py-2': ! is_small }"
    class="rounded-full relative inline-flex items-center mx-auto group text-center text-base font-bold uppercase whitespace-nowrap overflow-hidden border-2 border-riverbed-violet text-riverbed-violet bg-white"
  >
    <span class="relative z-10 flex-1">Extend</span>
  </a>
</template>
